import {ApiClientService} from '@dofleini/security';
import {API_SETTINGS} from '../constants/api.settings';
import {handleUserResponse} from '../utils/storage.utils';

export function login(formData) {
  return ApiClientService.post(`${API_SETTINGS.auth}/signin`, formData).then(handleUserResponse);
}

export function register({username, password}) {
  return ApiClientService('register', {body: {username, password}}).then(handleUserResponse);
}

export function logout() {
  return new Promise((resolve) => {
    window.localStorage.clear();
    resolve();
  });
}
